import { forwardRef, type ComponentPropsWithoutRef } from 'react'

import { cn } from '#app/utils/misc.tsx'

type ParagraphProps = ComponentPropsWithoutRef<'p'>

const Subtitle = forwardRef<HTMLParagraphElement, ParagraphProps>(
	({ className, ...props }, ref) => (
		<p
			ref={ref}
			className={cn('text-xs font-semibold tracking-wide uppercase', className)}
			{...props}
		/>
	),
)
Subtitle.displayName = 'TypographySubtitle'

const Title = forwardRef<HTMLParagraphElement, ParagraphProps>(
	({ className, ...props }, ref) => (
		<p
			ref={ref}
			className={cn('text-foreground text-2xl font-semibold', className)}
			{...props}
		/>
	),
)
Title.displayName = 'TypographyTitle'

const Description = forwardRef<HTMLParagraphElement, ParagraphProps>(
	({ className, ...props }, ref) => (
		<p
			ref={ref}
			className={cn('text-muted-foreground text-sm', className)}
			{...props}
		/>
	),
)
Description.displayName = 'TypographyDescription'

export const Typography = {
	Subtitle,
	Title,
	Description,
} as const
